import { useState } from 'react';
import { endpoints } from '../api/endpoints';
import { useAuth } from '../store/auth';
import { ApiException } from '../api/client';
import { ConsentNotice } from './ConsentNotice';
import { SpecialConsentNotice } from './SpecialConsentNotice';

// Блокирующий экран согласия. Показывается из Protected, когда у авторизованного
// пользователя ещё нет (актуального) согласия: вход в Telegram и существующие тестеры.
export function ConsentScreen() {
  const setConsentRequired = useAuth((s) => s.setConsentRequired);
  const setSpecialConsent = useAuth((s) => s.setSpecialConsent);
  const [agreed, setAgreed] = useState(false);
  // Вторая (необязательная) галочка — согласие на спец-категории (Часть 2: здоровье/диета).
  const [special, setSpecial] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function accept() {
    setError(null);
    setLoading(true);
    try {
      await endpoints.acceptConsent(special);
      setConsentRequired(false);
      setSpecialConsent(special);
    } catch (e) {
      setError(e instanceof ApiException ? e.body.message : 'Не удалось сохранить согласие. Попробуйте ещё раз.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="fixed inset-0 z-50 mx-auto flex max-w-md flex-col justify-center bg-cream px-6 pb-[calc(2rem+env(safe-area-inset-bottom))] pt-[calc(1.5rem+env(safe-area-inset-top))]">
      <h1 className="mb-3 text-[26px] font-bold leading-tight text-ink">Перед началом</h1>
      <p className="mb-6 text-[15px] leading-relaxed text-ink/70">
        Чтобы пользоваться Рецепт.ИИ, подтвердите согласие на обработку ваших данных.
      </p>

      <label className="mb-4 flex items-start gap-3 text-[14px] leading-relaxed text-ink/80">
        <input
          type="checkbox"
          checked={agreed}
          onChange={(e) => setAgreed(e.target.checked)}
          className="mt-0.5 h-5 w-5 flex-none accent-primary-600"
        />
        <span><ConsentNotice /></span>
      </label>

      <label className="mb-5 flex items-start gap-3 text-[14px] leading-relaxed text-ink/80">
        <input
          type="checkbox"
          checked={special}
          onChange={(e) => setSpecial(e.target.checked)}
          className="mt-0.5 h-5 w-5 flex-none accent-primary-600"
        />
        <span><SpecialConsentNotice /></span>
      </label>

      <button
        onClick={() => void accept()}
        disabled={!agreed || loading}
        className="w-full rounded-xl bg-primary-600 px-4 py-3.5 font-semibold text-white shadow-card transition active:scale-[0.98] disabled:cursor-not-allowed disabled:bg-gray-300"
      >
        {loading ? 'Сохраняем…' : 'Принимаю'}
      </button>

      {error && (
        <p role="alert" className="mt-4 text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  );
}
